import { useSelector } from 'react-redux'
import { RootState } from "../../../setup/redux/RootReducer";
import { useHistory } from "react-router-dom";

export default function BackButton() {

    const pageLinks = useSelector((state: RootState) => state.pageLinkReducer);

    const history = useHistory();


    const backButton = () => {
        console.log("pageLinks =>", pageLinks);
        if (pageLinks.PageLinkList?.length == 1) {
            history.push('/');
        }

        var lastItem = pageLinks.PageLinkList![pageLinks.PageLinkList!.length - 1]

        history.push(lastItem?.path as any);
    }

    return (
        <>
            <span onClick={() => backButton()} className="backButtonCss" >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                </svg>
            </span>
        </>
    )
}